import moment from 'moment'

export const collectMissingReportDates = (start, end) => {
  const dates = []
  let currentDate, endDate

  currentDate = moment(start).startOf('day')
  endDate = moment(end).startOf('day')

  while (currentDate <= endDate) {
    dates.push(currentDate.format('YYYY-MM-DD'))
    currentDate.add(1, 'days')
  }

  return dates
}
